<template>
  <b-container>
    <Nav :showoverlay="showoverlay"></Nav>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row><b-col><h2>DASH<b>BOARD</b></h2></b-col></b-row>
      <DailyStatsDash></DailyStatsDash>
      <b-row>
        <b-col cols="12" md="6">
          <b-row>
            <b-col>
              <OrderStatsChart></OrderStatsChart>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <TopItemsTable></TopItemsTable>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6">
          <h4>NEW<b>ORDERS</b></h4>
          <b-card-group columns style="column-count: 1;" v-if="total_orders>0">
            <OrderInfo
            v-for="order of orders"
            v-bind:key="order.id"
            :order="order">
          </OrderInfo>
          </b-card-group>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import Nav from '@/components/Nav.vue'
import DailyStatsDash from '@/components/DailyStatsDash.vue'
import OrderStatsChart from '@/components/OrderStatsChart.vue'
import TopItemsTable from '@/components/TopItemsTable.vue'
import OrderInfo from '@/components/OrderInfo.vue'
export default {
  name: "Dashboard",
  components: {
    Nav,
    DailyStatsDash,
    OrderStatsChart,
    TopItemsTable,
    OrderInfo
  },
  data() {
    var audio = new Audio(require('../assets/cash-register-cha-ching-9.mp3'))
    return {
      orderstats: [],
      statsperiod: 'daily',
      showoverlay: false,
      timer: '',
      total_orders: 0,
      current_location: 0,
      orders: [],
      audio
    };
  },

  computed: {
  },

  methods: {
    async fetchLocations() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      await this.$api.get("locations", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      }).then(response=> {
        // console.log(response);
        if (response.data.success==true) {
          const locations = response.data.locations;
          const sortedlocations = locations.sort((a,b) => a.id - b.id);
          this.current_location = sortedlocations[0].id;
          // set order count to 0 before polling for new orders / updating order list
          this.orderCount = 0;
          this.pollForOrders()
        } else {
          this.showoverlay=false;
        }
      })
      .catch(error => {
        console.log(error)
        this.showoverlay=false;
      })
    },

    async pollForOrders() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {"order_count": this.orderCount};
      // check to see if there are any new orders for this location
      const { data } = await this.$api.post('locations/'+this.current_location+'/orders', body, config);
      if (data.new_order == true) {
        if(this.orderCount > 0)
        {
          this.audio.play();
        }
        this.orderCount = data.order_count;
        this.fetchOrders();
      }
    },

    async fetchOrders() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations/"+this.current_location+"/orders?page=1&limit=5&status=in:3,6&sortby=-time_taken", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.orders = data.orders.slice(0,5);
      this.total_orders = data.total_orders;
      this.showoverlay = false;
    },
  },

  beforeDestroy () {
    clearInterval(this.timer)
  },

  created: function() {
    this.fetchLocations();
    this.timer = setInterval(this.pollForOrders, 60000)
  },

};
</script>
<style>


  @import '../styles/style.css';

</style>
